import { useApplicationAccountQuery, useCreateApplicationAccountMutation, useUpdateApplicationAccountMutation, useDeleteApplicationAccountMutation } from './useApplicationAccountsQuery';
import { ApplicationAccount } from '../types';

export const useApplicationAccount = (applicationId: string, accountId?: string) => {

    if (!applicationId) {
        throw new Error('applicationId is required parameter');
    }

    const { data: record, isLoading: loading, refetch: fetchRecord } = useApplicationAccountQuery(accountId || '');
    const createApplicationAccountMutation = useCreateApplicationAccountMutation();
    const updateApplicationAccountMutation = useUpdateApplicationAccountMutation();
    const deleteApplicationAccountMutation = useDeleteApplicationAccountMutation();

    const createRecord = async (values: ApplicationAccount) => {
        values.applicationId = applicationId;
        return await createApplicationAccountMutation.mutateAsync(values);
    };

    const updateRecord = async (values: ApplicationAccount) => {
        if (typeof applicationId === 'undefined') {
            throw new Error('applicationId is required parameter');
        }
        return await updateApplicationAccountMutation.mutateAsync({ id: applicationId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof applicationId === 'undefined') {
            throw new Error('applicationId is required parameter');
        }
        return await deleteApplicationAccountMutation.mutateAsync(applicationId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
